export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./list.vue?vue&type=template&id=0bd31e75"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/games/list.vue?vue&type=template&id=0bd31e75
// module id = JjKX
// module chunks = 0